var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.isMobile && _vm.renderGif && _vm.isGifLoading)?_c('MobileHome'):_vm._e(),(!_vm.renderGif ? _vm.isLoading : '')?_c('div',{attrs:{"id":"loading-wrapper"}},[_c('div',{attrs:{"id":"loading-text"}},[_vm._v("LOADING")]),_c('div',{attrs:{"id":"loading-content"}})]):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }